module.exports = __webpack_public_path__ + "media/1_5.07e7c228.wav";